// components/layout/ModalSearch.tsx

import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import SearchComponent from '@/components/layout/search/SearchComponent';

interface ModalSearchProps {
    isModalOpen: boolean;
    closeModal: () => void;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>> | ((open: boolean) => void);
}

const SearchModal: React.FC<ModalSearchProps> = ({ isModalOpen, closeModal, setIsModalOpen }) => {
    return (
        <Dialog
            open={isModalOpen}
            onOpenChange={(open) => {
                if (!open) closeModal();
            }}
        >
            <DialogContent
                overlayClassName='z-[10000001]'
                className='z-[10000002] inline-block customContainer h-full lg:h-[90%] max-w-full overflow-hidden bg-white p-6 text-left align-middle transition-all dark:bg-primary-active border-0 lg:border-white/15'
            >
                <DialogHeader>
                    <DialogTitle className='mb-5 w-full text-center text-lg leading-6 text-gray-900 dark:text-white'>
                        جستجو
                    </DialogTitle>
                </DialogHeader>
                <SearchComponent closeModal={setIsModalOpen} />
            </DialogContent>
        </Dialog>
    );
};

export default SearchModal;
